module.exports = __webpack_public_path__ + "0bcab8760ac2dd13c462a5b054464a59.jpeg";